import { render } from "./legoDropHolderStaticMethodExtend.vue?vue&type=template&id=58b8e0fc&scoped=true"
import script from "./legoDropHolderStaticMethodExtend.vue?vue&type=script&lang=js"
export * from "./legoDropHolderStaticMethodExtend.vue?vue&type=script&lang=js"

import "./legoDropHolderStaticMethodExtend.vue?vue&type=style&index=0&id=58b8e0fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b8e0fc"],['__file',"src/components/lego/extend/legoDropHolderStaticMethodExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58b8e0fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58b8e0fc', __exports__)) {
    api.reload('58b8e0fc', __exports__)
  }
  
  module.hot.accept("./legoDropHolderStaticMethodExtend.vue?vue&type=template&id=58b8e0fc&scoped=true", () => {
    api.rerender('58b8e0fc', render)
  })

}


export default __exports__